import { RouteChunkStallError } from '@client/utils/routing/route-chunk-stall';
import type { ErrorBoundaryProps } from '@sentry/react';

/**
 * Sentry grouping for a route whose code stopped arriving: one issue per route, whichever build's
 * chunk hung, with which budget ran out, how long the code had been loading and the unanswered
 * preloads as the detail. Undefined for any other error.
 */
export function routeChunkStallCapture(error: unknown) {
    if (!(error instanceof RouteChunkStallError)) {
        return undefined;
    }
    return {
        fingerprint: ['route-chunk-stall', error.routeId],
        extra: { reason: error.reason, elapsedMs: error.elapsedMs, unansweredAssets: error.unansweredAssets },
    };
}

/**
 * `beforeCapture` for a `Sentry.ErrorBoundary` that a stalled route can reach: gives the
 * boundary's own report the grouping its fallback's explicit capture uses.
 */
export const groupRouteChunkStall: NonNullable<ErrorBoundaryProps['beforeCapture']> = (scope, error) => {
    const stall = routeChunkStallCapture(error);
    if (stall) {
        scope.setFingerprint(stall.fingerprint);
        scope.setExtras(stall.extra);
    }
};
